import { useParams, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useState, useContext, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { contentDetails, updateUserPorgress } from "ServerAPI/serverAPI";

const NavigationButton = ({
  courseDetails,
  activeContent,
  setActiveContent,
}) => {
  const { courseId, sectionId } = useParams();
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const [isNextLoading, setIsNextLoading] = useState(false);
  const [isLastContent, seIsLastContent] = useState(false);
  const [isFirstContent, setIsFirstContent] = useState(false);

  useEffect(() => {
    const sectionLength = courseDetails?.sections?.length;
    const lastContentLength =
      courseDetails?.sections[sectionLength - 1].courseContent?.length;
    const firstContent = courseDetails?.sections[0]?.courseContent[0];
    const lastContent =
      courseDetails?.sections[sectionLength - 1]?.courseContent[
        lastContentLength - 1
      ];

    if (lastContent?.contentId === activeContent?.contentId) {
      seIsLastContent(true);
    } else {
      seIsLastContent(false);
    }
    if (firstContent?.contentId === activeContent?.contentId) {
      setIsFirstContent(true);
    } else {
      setIsFirstContent(false);
    }
  }, [activeContent]);

  const goToPreviousSection = async () => {
    let activeSection = courseDetails?.sections?.find(
      (section) => section.sectionId === sectionId
    );
    let prevContent = activeSection?.courseContent?.find(
      (content) => content.contentNumber === activeContent.contentNumber - 1
    );

    if (!prevContent) {
      const prevSection = courseDetails?.sections?.find(
        (section) => section.sectionNumber === activeSection?.sectionNumber - 1
      );
      prevContent = prevSection?.courseContent?.find(
        (content) =>
          content.contentNumber === prevSection?.courseContent?.length
      );
      activeSection = prevSection;
    }

    if (!activeSection && !prevContent) {
      return;
    }
    navigate(
      `/view-course/${courseId}/${activeSection.sectionId}/${prevContent.contentId}`
    );

    prevContent && setActiveContent(prevContent);
  };

  const goToNextSection = async () => {
    try {
      setIsNextLoading(true);
      const body = {
        userId: cookies.userId,
        courseId,
        sectionId,
        contentId: activeContent.contentId,
      };

      cookies.roleId === "courseParticipant" &&
        (await updateUserPorgress(body));
      let activeSection = courseDetails?.sections?.find(
        (section) => section.sectionId === sectionId
      );
      let nextContent = activeSection?.courseContent?.find(
        (content) => content.contentNumber === activeContent.contentNumber + 1
      );

      if (!nextContent) {
        const nextSection = courseDetails?.sections?.find(
          (section) =>
            section.sectionNumber === activeSection?.sectionNumber + 1
        );
        nextContent = nextSection?.courseContent?.find(
          (content) => content.contentNumber === 1
        );
        activeSection = nextSection;
      }

      if (!activeSection && !nextContent) {
        return;
      }

      navigate(
        `/view-course/${courseId}/${activeSection?.sectionId}/${nextContent?.contentId}`
      );

      nextContent && setActiveContent(nextContent);
      setIsNextLoading(false);
    } catch (e) {
      console.log(e);
      setIsNextLoading(false);
    }
  };

  return (
    <section className="course-container">
      <Container fluid>
        <Row>
          <Col sm={12} md={12} lg={12}>
            <div className="content">
              <div className="d-flex justify-content-between">
                <div>
                  <Button
                    className={`mt-4 ${isFirstContent ? "d-none" : ""}`}
                    variant="outline-primary"
                    onClick={goToPreviousSection}
                    disabled={isFirstContent}
                  >
                    Previous
                  </Button>
                </div>
                <Button
                  className={`mt-4 ${isLastContent ? "d-none" : ""}`}
                  onClick={goToNextSection}
                  disabled={isLastContent}
                >
                  Next
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NavigationButton;
